import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";
import ScratchGenerator from "./pages/ScratchGenerator";
import Report from "./pages/Report";
import Dashboard from "./pages/Dashboard";
import { useEffect, useState } from "react";
import PrivateRoute from "./components/PrivateRoute";
import Fake from "./pages/Fake";
import Genuine from "./pages/Genuine";
import AccessRights from "./components/AccessRights";
import DeMapping from "./components/DeMapping";
import Damage from "./components/Damage";
import User from "./components/UserMaster";
import DemappingReport from "./components/DemappingReport";
import Damagerpt from "./components/DamageReport";
import Mappingrpt from "./components/Mappingreport";
import Mapping from "./pages/Mapping";
import Feedbackrpt from "./components/FeedbackReport";
import IssueNumbers from "./components/IssueNumbers";
import Product from "./pages/Product";
import Qr_Report from "./pages/Qr_Report";
import CartonSlips from "./components/CartonSlips";
import WarehouseMaster from "./components/WarehouseMaster";
import DistributorMaster from "./components/DistributorMaster";
import RetailerMaster from "./components/RetailerMaster";
import CartonMaster from "./components/CartonMaster";
import ShippersPackingRpt from "./components/ShippersPackingRpt";
import DispatchReport from "./components/DispatchReport";
import PackingReport from "./components/PackingReport";
import TrackingReport from "./components/TrackingReport";
import StockSummary from "./components/StockSummary";
import BatchTracking from "./components/BatchTracking";
import ContestThankYou from "./pages/ContestThankYou";
import ContestBatchMaster from "./components/ContestBatchMaster";
import ContestUserReport from "./components/ContestUserReport";
import IsopureAuth from "./pages/IsopureAuth";
import BSNAuth from "./pages/BSNAuth";
import ContestWinnerEmail from "./components/ContestWinnerEmail";
import ISO from "./pages/ISO";
import { useBrand } from "./helper/BrandContext";
import IsopureHeader from "./components/IsopureHeader";
import UniqueReport from "./pages/UniqueReport";
import Unique_Qr_Report from "./pages/Unique_Qr_Report";
import DispatchDistributorReport from "./components/DispatchDistributorReport";
import DispatchRetailerReport from "./components/DispatchRetailerReport";

function App() {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const storedToken = sessionStorage.getItem("token");
    const refreshToken = sessionStorage.getItem("refreshToken");
    return storedToken && refreshToken ? true : false;
  });

  const [isON, setIsON] = useState(false);
  const [shouldShowIsoHeader, setShouldShowIsoHeader] = useState(false);
  const { brand } = useBrand();

  useEffect(() => {
    const pathname = location.pathname.toLowerCase();

    // Check if the header should be shown
    const shouldShow =
      pathname === "/iso" ||
      (sessionStorage.getItem("showIsoHeader") === "true" &&
        (pathname.includes("genuine") || pathname.includes("fake")));
    setShouldShowIsoHeader(shouldShow);

    // Persist this state to session storage
    sessionStorage.setItem("showIsoHeader", shouldShow ? "true" : "false");

    // Set isON based on current path
    setIsON(
      shouldShow ||
        pathname.includes("isopure") ||
        pathname.includes("bsn") ||
        pathname.includes("iso"),
    );
  }, [location.pathname]);

  return (
    <>
      <div
        hidden={!isON}
        className="w-screen h-screen flex flex-col text-center "
      >
        <div hidden={!shouldShowIsoHeader}>
          <IsopureHeader />
        </div>
        <Routes>
          <Route
            path="/isopure"
            element={<IsopureAuth isLoggedIn={isLoggedIn} />}
          />
          <Route path="/bsn" element={<BSNAuth isLoggedIn={isLoggedIn} />} />
          <Route path="/ISO" element={<ISO isLoggedIn={isLoggedIn} />} />
          <Route
            path="/fake"
            element={
              <PrivateRoute isLoggedIn={setIsLoggedIn}>
                <Fake isLoggedIn={setIsLoggedIn} />
              </PrivateRoute>
            }
          />
          <Route
            path="/genuine"
            element={
              <PrivateRoute isLoggedIn={setIsLoggedIn}>
                <Genuine isLoggedIn={setIsLoggedIn} />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
      <div
        hidden={isON}
        className="w-screen h-screen bg-richblack-900 flex flex-col"
      >
        <Navbar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}></Navbar>
        <Routes>
          <Route path="/" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
          <Route path="/pa" element={<Dashboard isLoggedIn={isLoggedIn} />} />
          <Route
            path="/login"
            element={<Login setIsLoggedIn={setIsLoggedIn} />}
          />
          <Route
            path="/fake"
            element={
              <PrivateRoute isLoggedIn={setIsLoggedIn}>
                <Fake isLoggedIn={setIsLoggedIn} />
              </PrivateRoute>
            }
          />
          <Route
            path="/genuine"
            element={
              <PrivateRoute isLoggedIn={setIsLoggedIn}>
                <Genuine isLoggedIn={setIsLoggedIn} />
              </PrivateRoute>
            }
          />
          <Route
            path="/thank-you"
            element={
              <PrivateRoute isLoggedIn={setIsLoggedIn}>
                <ContestThankYou isLoggedIn={setIsLoggedIn} />
              </PrivateRoute>
            }
          />
        </Routes>

        {isLoggedIn && brand ? (
          <Routes>
            <Route
              path="/scratchgenerate"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <ScratchGenerator isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/accessRights"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <AccessRights isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/demapping"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <DeMapping isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/damage"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <Damage isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/carton-slips"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <CartonSlips isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/verificationrpt"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <Report isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/unique-verification-report"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <UniqueReport isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/QrReport"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <Qr_Report isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/unique-qr-reports"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <Unique_Qr_Report isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/DemappingReport"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <DemappingReport isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/Damagerpt"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <Damagerpt isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/Mapping-report"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <Mappingrpt isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/feedbackrpt"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <Feedbackrpt isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <Home isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/user"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <User isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/productMaster"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <Product isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/mapping"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <Mapping isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/issuenumbers"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <IssueNumbers isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/warehouse-master"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <WarehouseMaster isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/distributor-master"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <DistributorMaster isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/retailer-master"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <RetailerMaster isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/carton-master"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <CartonMaster isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/shippers-packing-report"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <ShippersPackingRpt isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/stockreceive-report"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <DispatchReport isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/tracking-report"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <TrackingReport isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/stock-summary"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <StockSummary isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/batch-tracking"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <BatchTracking isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/contest-batch-master"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <ContestBatchMaster isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/contest-user-report"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <ContestUserReport isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/contest-winners"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <ContestWinnerEmail isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/packing-report"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <PackingReport isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            <Route
              path="/dispatch-distreport"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <DispatchDistributorReport isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/dispatch-retailer-report"
              element={
                <PrivateRoute isLoggedIn={setIsLoggedIn}>
                  <DispatchRetailerReport isLoggedIn={setIsLoggedIn} />
                </PrivateRoute>
              }
            /> */}
            
          </Routes>
        ) : isLoggedIn ? (
          <div className="flex flex-col items-center justify-center h-screen">
            <span style={{ fontSize: "20px" }}>
              Please Select Brand from Header to use Application
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default App;
